import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import myImg from "../../Assets/avatar.svg";

function Home2() {
  const socialLinks = [
    {
      icon: AiFillGithub,
      url: "https://github.com/Benedict-Kpaduwa",
      label: "GitHub",
    },
    {
      icon: AiOutlineTwitter,
      url: "https://twitter.com/Benedict___K",
      label: "Twitter",
    },
    {
      icon: FaLinkedinIn,
      url: "https://www.linkedin.com/in/benedictkpaduwa/",
      label: "LinkedIn",
    },
    {
      icon: AiFillInstagram,
      url: "https://www.instagram.com/benedict__k/",
      label: "Instagram",
    },
  ];

  return (
    <div
      className="relative py-20 bg-gradient-to-b from-dark-light to-dark"
      id="about"
    >
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12 items-center">
          {/* About Text */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="md:col-span-2 space-y-6"
          >
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center md:text-left">
              LET ME <span className="text-gradient">INTRODUCE</span> MYSELF
            </h1>

            <div className="text-base md:text-lg text-gray-300 space-y-4 leading-relaxed">
              <p>
                I fell in love with programming and I have at least learnt
                something, I think… 🤷‍♂️
              </p>

              <p>
                I am fluent in classics like{" "}
                <span className="text-purple-400 font-semibold">
                  Javascript/Typescript, C#, and C++
                </span>
                .
              </p>

              <p>
                My field of Interest's are building new{" "}
                <span className="text-purple-400 font-semibold">
                  Web Technologies and Products
                </span>{" "}
                and also in areas related to{" "}
                <span className="text-purple-400 font-semibold">
                  Extended Reality (VR/AR)
                </span>
                .
              </p>

              <p>
                Whenever possible, I also apply my passion for developing
                products with{" "}
                <span className="text-purple-400 font-semibold">Node.js</span>{" "}
                and{" "}
                <span className="text-purple-400 font-semibold">
                  Modern Javascript Library and Frameworks
                </span>{" "}
                like{" "}
                <span className="text-purple-400 font-semibold">
                  React.js and Next.js
                </span>
                .
              </p>
            </div>
          </motion.div>

          {/* Avatar */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="flex justify-center"
          >
            <Tilt tiltMaxAngleX={15} tiltMaxAngleY={15} scale={1.05}>
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full blur-2xl opacity-30 animate-pulse" />
                <img
                  src={myImg}
                  alt="avatar"
                  className="relative w-64 h-64 rounded-full"
                />
              </div>
            </Tilt>
          </motion.div>
        </div>

        {/* Social Links Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="mt-20 text-center space-y-8"
        >
          <h1 className="text-3xl md:text-4xl font-bold">FIND ME ON</h1>
          <p className="text-lg text-gray-300">
            Feel free to{" "}
            <span className="text-purple-400 font-semibold">connect</span> with
            me
          </p>

          <div className="flex justify-center items-center gap-6 flex-wrap">
            {socialLinks.map((social, index) => (
              <motion.a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.95 }}
                className="group relative w-16 h-16 flex items-center justify-center rounded-full bg-white text-purple-700 transition-all duration-300 hover:text-white"
                aria-label={social.label}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-0 group-hover:scale-110" />
                <social.icon className="relative text-2xl z-10" />
                <div className="absolute inset-0 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 blur-lg opacity-0 group-hover:opacity-50 transition-opacity duration-300" />
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Home2;
